import usePrivateAxios from "@/common/api/usePrivateAxios"
import { ErrorResponse } from "@/common/types/errorResponse"
import { useMutation } from "@tanstack/react-query"
import { AxiosResponse } from "axios"

interface UseCardManuallyActivate {
  id?: string
  onSuccess?: (response?: AxiosResponse<any, any>) => void
  onError?: (error: ErrorResponse) => void
}

export const useCardManuallyActivate = ({ id, onSuccess, onError }: UseCardManuallyActivate) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['cardManuallyActivate'],
    mutationFn: () => {
      return privateAxios.post(`/cards/${id}/manually_activate`)
    },
    onSuccess,
    onError,
  })
}
